import React from "react";

const CustomTooltip = ({ active, payload, label }) => {
	if (active) {
		// Check if data is not null or empty
		if (!payload || payload.length === 0) {
			return null;
		}

		// Calculate the total sum of data values
		const total = payload.reduce((sum, entry) => sum + entry.value, 0);

		return (
			<div className={"bg-white rounded-md border border-gray-600"}>
				<div className="p-2">
					<p>{`${label}`}</p>
					{payload.map((entry, index) => (
						<p key={index} style={{ color: entry.color }}>
							{`${entry.name}: ${entry.value} (${(
								(entry.value / total) *
								100
							).toFixed(2)}%)`}
						</p>
					))}
					<p>Total Packages: {total}</p>
				</div>
			</div>
		);
	}
};
export default CustomTooltip;
